
import { useState } from 'react';
import { serviceRegions } from '../../../mocks/serviceAreas';

export default function RegionCards() {
  const [expandedRegion, setExpandedRegion] = useState<number | null>(null);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-brand-red font-semibold text-sm uppercase tracking-widest mb-3">
            Regional Coverage
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-brand-navy mb-4">
            Major Service Regions
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We proudly serve six major regions across Florida with dedicated local teams ready to help you save on energy costs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {serviceRegions.map((region, i) => (
            <article
              key={i}
              className="group bg-white rounded-2xl border border-gray-100 overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <div className="relative w-full h-[220px] overflow-hidden">
                <img
                  src={region.image}
                  alt={`${region.name} service area`}
                  title={`${region.name} HVAC solar insulation services`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-5 right-5">
                  <h4 className="text-xl font-bold text-white">{region.name}</h4>
                  <p className="text-white/80 text-sm">{region.description}</p>
                </div>
              </div>

              <div className="p-5">
                <div className="flex items-center gap-4 mb-4">
                  <div className="flex items-center gap-1.5 text-sm text-gray-600">
                    <i className="ri-home-4-line text-brand-red w-4 h-4 flex items-center justify-center"></i>
                    <span><strong className="text-brand-navy">{region.stats.homes}</strong> homes served</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-sm text-gray-600">
                    <i className="ri-time-line text-brand-red w-4 h-4 flex items-center justify-center"></i>
                    <span><strong className="text-brand-navy">{region.stats.years}</strong> years active</span>
                  </div>
                </div>

                <button
                  onClick={() => setExpandedRegion(expandedRegion === i ? null : i)}
                  className="flex items-center gap-2 text-brand-red font-semibold text-sm hover:text-brand-red-dark transition-colors cursor-pointer whitespace-nowrap"
                >
                  {expandedRegion === i ? 'Hide Cities' : 'View All Cities'}
                  <i className={`ri-arrow-${expandedRegion === i ? 'up' : 'down'}-s-line w-4 h-4 flex items-center justify-center`}></i>
                </button>

                {expandedRegion === i && (
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <div className="grid grid-cols-2 gap-2">
                      {region.cities.map((city, j) => (
                        <div key={j} className="flex items-center gap-2 text-sm text-gray-700">
                          <i className="ri-map-pin-2-fill text-brand-gold text-xs w-3 h-3 flex items-center justify-center"></i>
                          {city}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
